<template>
    <div class="mainbody modulewrap">
        <div class="coursetop">
            <div class="realwrap">
                <div v-if="$store.getters.issmall" class="smallcsite">{{$common.langinfo(infodata.title,infodata.title_en)}}</div>
                <div v-else class="csite"><div class="info"><router-link to="/">{{$common.dicword('homepage')}}</router-link><span>&gt;</span><router-link :to="infodatacollege.isdemand?'/demand':'/college/'+infodatacollege.alias">{{$common.langinfo(infodatacollege.title,infodatacollege.title_en)}}</router-link><span>&gt;</span><span v-html="$common.langinfo(infodata.title,infodata.title_en)"></span></div></div>

                <div class="topinfo">
                    <div class="mainimg">
                        <img :src="infodata.banner" />
                    </div>
                    <div class="simple">
                        <div class="fav" v-if="$store.state.islogintt">
                            <a href="#" @click="myfav">
                                <i v-if="isfav" class="iconfont icon-favorite-filling"></i>
                                <i v-else class="iconfont icon-favorite"></i>
                            </a>
                        </div>
                        <div class="mentor" v-if="$common.basic.isobjexist(infodatamentor)">
                            <dl>
                                <dt><img :src="infodatamentor.avator" /></dt>
                                <dd>
                                    <span class="a">{{$common.langinfo(infodatamentor.title,infodatamentor.title_en)}}</span>
                                    <span class="b">{{$common.dicword('favouritelearn',true)}}{{infodata.favcount}}&nbsp;&nbsp;&nbsp;&nbsp;{{$common.dicword('learning',true)}}{{infodata.buycount}}</span>
                                </dd>
                            </dl>
                        </div>
                        <div class="info" v-if="infodata.isdemand">
                            {{$common.dicword('coursetype',true)}}{{infodata.isvip?'VIP':$common.dicword('openclass')}}&nbsp;&nbsp;&nbsp;&nbsp;

                        </div>
                        <template v-if="ismine && $common.basic.isobjexist(infodataexpire)">
                            <div class="info" v-if="infodataexpire.expireday!=0">{{$common.dicword('expirydate',true)}}{{$common.basic.dateformat(infodataexpire.datebegin)}}/{{$common.basic.dateformat(infodataexpire.dateend)}}</div>
                        </template>


                        <div class="info">
                            {{$common.dicword('coursewares',true)}} {{maxtopic}}
                        </div>
                        <div class="info" v-if="durationall">
                            {{$common.dicword('classhour',true)}}{{$common.basic.chint2timewithsecond(durationall)}}
                        </div>
                        <div class="info" v-if="$common.basic.isarrayexist(infodatatool)">
                            <dl class="tool">
                                <dt>{{$common.dicword('usetool',true)}}</dt>
                                <dd v-for="item in infodatatool" :key="item.id"><img :src="item.icon" /></dd>
                            </dl>
                        </div>
                        <div class="info" v-if="infodata.conrequire||infodata.conrequire_en">
                            <dl>
                                <dt>{{$common.dicword('learnrequirements',true)}}</dt>
                                <dd v-html="$common.langinfo(infodata.conrequire,infodata.conrequire_en)"></dd>
                            </dl>
                        </div>
                        <div class="infobtn" v-if="lasttopicid">
                            <router-link :to="'/learn/'+lasttopicid" class="btn1">{{$common.dicword('goonlearn')}}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="coursebody">
            <div class="realwrap">
                <div class="courseintro" v-if="(infodata.content||infodata.content_en) && !infodata.isdemand">
                    <div class="subtitle"><div class="word"><span>{{$common.dicword('courseintroduction')}}</span></div></div>
                    <div class="con editor" v-html="$common.langinfo(infodata.content,infodata.content_en)"></div>
                </div>

                <div class="coursetopic">
                    <div class="subtitle"><div class="word"><span>{{$common.dicword('coursecatalogue')}}</span></div></div>

                    <div class="list laster" v-if="infodatatopic.length>10 && infodatacollege.isdemand ">
                        <router-link v-for="(item,index) in infodatatopic" :key="item.id" v-if="ismine && (index>infodatatopic.length-4)" :to="'/learn/'+item.id">
                            <dl>
                                <dt>{{$common.basic.padleft(index+1)}}</dt>
                                <dd class="a">{{$common.langinfo(item.title,item.title_en)}}</dd>
                                <dd class="b">{{item.duration?$common.basic.chint2timewithsecond(item.duration):''}}</dd>
                            </dl>
                        </router-link>
                        <dl v-for="(item,index) in infodatatopic" :key="item.id" v-if="!ismine && (index>infodatatopic.length-4)">
                            <dt>{{$common.basic.padleft(index+1)}}</dt>
                            <dd class="a">{{$common.langinfo(item.title,item.title_en)}}</dd>
                            <dd class="b">{{item.duration?$common.basic.chint2timewithsecond(item.duration):''}}</dd>
                        </dl>
                    </div>

                    <div class="list">
                        <router-link v-for="(item,index) in infodatatopic" :key="item.id" v-if="ismine && index<mintopic" :to="'/learn/'+item.id">
                            <dl>
                                <dt>{{$common.basic.padleft(index+1)}}</dt>
                                <dd class="a">{{$common.langinfo(item.title,item.title_en)}}</dd>
                                <dd class="b">{{item.duration?$common.basic.chint2timewithsecond(item.duration):''}}</dd>
                            </dl>
                        </router-link>
                        <dl v-for="(item,index) in infodatatopic" :key="item.id" v-if="!ismine && index<mintopic">
                            <dt>{{$common.basic.padleft(index+1)}}</dt>
                            <dd class="a">{{$common.langinfo(item.title,item.title_en)}}</dd>
                            <dd class="b">{{item.duration?$common.basic.chint2timewithsecond(item.duration):''}}</dd>
                        </dl>
                    </div>
                    <transition name="slidedown">
                        <div class="list" v-show="curtopic>mintopic">
                            <router-link v-for="(item,index) in infodatatopic" :key="item.id" v-if="ismine && index>=mintopic && index<curtopic" :to="'/learn/'+item.id">
                                <dl>
                                    <dt>{{$common.basic.padleft(index+1)}}</dt>
                                    <dd class="a">{{$common.langinfo(item.title,item.title_en)}}</dd>
                                    <dd class="b">{{item.duration?$common.basic.chint2timewithsecond(item.duration):''}}</dd>
                                </dl>
                            </router-link>
                            <dl v-for="(item,index) in infodatatopic" :key="item.id" v-if="!ismine && index>=mintopic && index<curtopic">
                                <dt>{{$common.basic.padleft(index+1)}}</dt>
                                <dd class="a">{{$common.langinfo(item.title,item.title_en)}}</dd>
                                <dd class="b">{{item.duration?$common.basic.chint2timewithsecond(item.duration):''}}</dd>
                            </dl>
                        </div>
                    </transition>
                    <div class="more" v-if="mintopic<maxtopic"><a href="#" @click="moretopic">{{$common.dicword(curtopic==maxtopic?'close':'open')}}<br /><i :class="['iconfont','icon-shiyuanjiaosanjiao',firstshowtopic?'': curtopic==maxtopic ? 'transitionrotate':'transitionrotateback']"></i></a></div>
                </div>

                <div class="coursementor" v-if="$common.basic.isobjexist(infodatamentor)">
                    <div class="subtitle"><div class="word"><span>{{$common.dicword('coursementor')}}</span></div></div>
                    <div class="mentorface">
                        <img :src="infodatamentor.avator" />{{$common.langinfo(infodatamentor.title,infodatamentor.title_en)}}
                    </div>
                    <div class="con editor" v-html="$common.langinfo(infodatamentor.content,infodatamentor.content_en)"></div>
                    <div class="authorwrap">

                        <div class="thirdtitle"><dl><dt></dt><dd>{{$common.dicword('ourworks')}}</dd></dl></div>
                        <div class="author" v-viewer>
                            <div class="swiperarrow"><a href="#" @click="$refs.myswiper.goprev();" v-if="authors.length>3"><i class="iconfont icon-fanye"></i></a></div>
                            <div class="swiper"><ffswiperimg ref="myswiper" :infolist="authors" :options="swiperopiton" :step="3"></ffswiperimg></div>
                            <div class="swiperarrow"><a href="#" @click="$refs.myswiper.gonext();" v-if="authors.length>3"><i class="iconfont icon-fanye1"></i></a></div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'course',
        data() {
            return {
                infodata: {},
                infodatacollege: {},
                infodatamentor: {},
                infodatatool: {},
                infodatatopic: {},
                swiperindex: 0,
                swiperdirect: 1,
                swiperopiton: { 'isautoplay': false, 'isstop': false },
                mintopic: 9,
                maxtopic: 999,
                curtopic: 9,
                firstshowtopic: true,
                isfav: false,
                ismine: false,
                infodataexpire: {},
                lasttopicid: 0
            }
        },
        computed: {
            authors: function () {
                let _authors = [];

                if (this.infodatamentor.imgs) {
                    _authors = this.infodatamentor.imgs.split(',');
                }
                return _authors;
            },
            durationall: function () {
                let _durationall = 0;
                this.$common.each(this.infodatatopic, item => {
                    _durationall += item.duration;
                });
                return _durationall;
            }
        },
        methods: {
            getdata() {
                let id = this.$common.basic.chstr2int(this.$route.params.id);
                let jsondata = { 'postdata': { 'act': 'tea_course', 'id': id }, 'msg': '', 'needid': true };
                this.$common.post(jsondata, res => {
                    res.infodata.buycount += res.infodatalearncount;
                    this.infodata = res.infodata;
                    this.infodatacollege = res.infodatacollege;
                    this.infodatamentor = res.infodatamentor;
                    this.infodatatool = res.infodatatool;
                    this.infodatatopic = res.infodatatopic;
                    this.maxtopic = this.infodatatopic.length;
                    this.isfav = res.infodatafav.id > 0;
                    this.ismine = res.ismine;
                    this.infodataexpire = res.infodataexpire;
                    this.$emit("setcollegeid", this.infodatacollege.isprivate == 1 ? 0 : this.infodatacollege.id);

                    this.lasttopicid = this.$common.basic.isobjexist(res.infodatalasttopic) ? res.infodatalasttopic.topicid : 0;
                    this.$store.commit('SET_TOPNAV', res.infodatacollege.isdemand ? 5 : 2);
                });
            },
            moretopic: function () {
                this.firstshowtopic = false;
                if (this.curtopic == this.maxtopic) {
                    this.curtopic = this.mintopic;
                }
                else {
                    this.curtopic = this.maxtopic;
                }
            },
            myfav: function () {
                let jsondata = {
                    'postdata': { 'act': 'tea_course_fav', 'id': this.infodata.id, 'data': { 'fav': this.isfav ? 0 : 1 } }, 'msg': ''
                };
                this.$common.post(jsondata, () => {
                    this.infodata.favcount += (this.isfav ? -1 : 1);
                    this.isfav = !this.isfav;
                });


            }
        },
        mounted() {
            this.getdata();
        }
    }
</script>
